import Nullstack from 'nullstack';
export default function IconAsset({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-asset",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "15",
    r: "6"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M14.218 17.975l6.619 -12.174"
  }), "   ", Nullstack.element("path", {
    d: "M6.079 9.756l12.217 -6.631"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "15",
    r: "2"
  }), " ");
}